export default __webpack_public_path__ + "static/media/policy.3315b68b.svg";